// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___8F0Ez"};